import { render, staticRenderFns } from "./ListaGrupoAvaliacao.vue?vue&type=template&id=6be147dc"
import script from "./ListaGrupoAvaliacao.vue?vue&type=script&lang=js"
export * from "./ListaGrupoAvaliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports